<template>
    <div class="" v-if="when">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'visible',
    props: ['when']
}
</script>

<style>

</style>